import { useSelector } from "react-redux";
import { selectVersion } from "../../features/counter/counterSlice";
import styles from "./VersionIndicatorBanner.module.scss";

const VersionIndicatorBanner = () => {
  const version = useSelector(selectVersion);
  const defaultVersion = import.meta.env.REACT_APP_CCMS_VERSION;
  const sessionVersion = sessionStorage.getItem("ccms_selected_version");

  if (!sessionVersion || sessionVersion === defaultVersion) {
    return null;
  }

  const handleClose = () => {
    sessionStorage.removeItem("ccms_selected_version");
    sessionStorage.removeItem("ccms_selected_version");
    Object.keys(sessionStorage).forEach(
      (key) => key.endsWith("_enabled") && sessionStorage.removeItem(key),
    );
    window.location.reload();
  };

  return (
    <span className={styles.banner} role="alert">
      <div className={styles.message}>
        &nbsp;&nbsp;
        <small>
          You are viewing content version<strong> {version.selected}. </strong>
          To return to the default version ({defaultVersion}), click{" "}
          <button
            className={styles.resetButton}
            onClick={handleClose}
            aria-label="Return to default version"
          >
            Reset
          </button>{" "}
          or open a new tab.
        </small>
      </div>
    </span>
  );
};

export default VersionIndicatorBanner;
